import { render, staticRenderFns } from "./bannerFrame.vue?vue&type=template&id=e356b128"
import script from "./bannerFrame.vue?vue&type=script&lang=js"
export * from "./bannerFrame.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports